// get product interest data
export const GET_CP_PRODUCT_INTEREST_DATA = 'GET_CP_PRODUCT_INTEREST_DATA';

export const GET_CP_PRODUCT_INTEREST_DATA_SUCCESS = 'GET_CP_PRODUCT_INTEREST_DATA_SUCCESS';

export const GET_CP_PRODUCT_INTEREST_DATA_FAILED = 'GET_CP_PRODUCT_INTEREST_DATA_FAILED';